/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteMiscSettingResponseData,
  GetSiteMiscSettingResponseDataFromJSON,
  GetSiteMiscSettingResponseDataFromJSONTyped,
  GetSiteMiscSettingResponseDataToJSON
} from './GetSiteMiscSettingResponseData'

/**
 *
 * @export
 * @interface GetSiteMiscSettingResponse
 */
export interface GetSiteMiscSettingResponse {
  /**
   *
   * @type {number}
   * @memberof GetSiteMiscSettingResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteMiscSettingResponseData}
   * @memberof GetSiteMiscSettingResponse
   */
  data?: GetSiteMiscSettingResponseData
}

export function GetSiteMiscSettingResponseFromJSON(json: any): GetSiteMiscSettingResponse {
  return GetSiteMiscSettingResponseFromJSONTyped(json, false)
}

export function GetSiteMiscSettingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSiteMiscSettingResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteMiscSettingResponseDataFromJSON(json['data'])
  }
}

export function GetSiteMiscSettingResponseToJSON(value?: GetSiteMiscSettingResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteMiscSettingResponseDataToJSON(value.data)
  }
}
